export const testimonials = {
  // SEO
  'seo.title': 'Kundeanmeldelser — Suksesshistorier | Sofia og Elena Ernæringsfysiologer',
  'seo.description': 'Les ekte anmeldelser fra våre klienter om arbeid med Sofia og Elena. Suksesshistorier innen barneernæring, gjenoppretting av hormonell balanse, FMD-protokoll og felles støtte fra to eksperter.',
  'seo.keywords': 'ernæringsfysiolog anmeldelser, ernæringsresultater, suksesshistorier, barneernæring anmeldelser, FMD protokoll resultater, helsegjenoppretting',

  // Hero Section
  'hero.title': 'Hva våre klienter sier',
  'hero.description': 'Vi selger ikke resultater — vi selger følelser. Historier om de som forelsket seg i seg selv igjen.',

  // Testimonial 1
  'testimonial1.category': 'Barneernæring',
  'testimonial1.name': 'Anna M.',
  'testimonial1.text': 'Barnet mitt begynte å spise grønnsaker og sluttet å bli syk hver høst. Sofia er vår engel! Hvert måltid pleide å være en kamp, og nå ber datteren min selv om brokkoli. Jeg trodde ikke det var mulig.',
  'testimonial1.highlight': 'Barnet begynte å spise grønnsaker og sluttet å bli syk',

  // Testimonial 2
  'testimonial2.category': 'Felles støtte',
  'testimonial2.name': 'Maria K.',
  'testimonial2.text': 'Det var et ekte konsultasjonsteam! Den ene fant årsaken i skjoldbruskkjertelen, den andre lærte meg å spise deilig og nyte prosessen. Jeg føler meg 10 år yngre. Energien kom tilbake, huden stråler, og jeg forelsket meg i speilbildet mitt igjen.',
  'testimonial2.highlight': 'Jeg føler meg 10 år yngre',

  // Testimonial 3
  'testimonial3.category': 'FMD-protokoll',
  'testimonial3.name': 'Ekaterina L.',
  'testimonial3.text': '5 dager som erstattet en ferie for meg. Letthet, klart sinn og utrolig energi. Jeg forventet ikke en slik effekt! Jeg føler hvordan kroppen min fornyet seg innenfra. Dette er ikke en diett — det er en omstart av hele kroppen.',
  'testimonial3.highlight': '5 dager som erstattet en ferie',

  // Testimonial 4
  'testimonial4.category': 'Barneernæring',
  'testimonial4.name': 'Olga V.',
  'testimonial4.text': 'Min allergiske sønn spiser nå variert og med glede. Sofia hjalp oss med å bygge et ernæringssystem som fungerer for hele familien. Ikke mer utslett og endeløse begrensninger. Takk for å returnere til et normalt liv!',
  'testimonial4.highlight': 'Ikke mer utslett',

  // Testimonial 5
  'testimonial5.category': 'Felles støtte',
  'testimonial5.name': 'Daria S.',
  'testimonial5.text': 'Dobbel ekspertise er det jeg trengte. Mens Elena tok seg av mage-tarm og hormoner, bygde Sofia ernæring slik at jeg gikk ned i vekt, men ansiktet mitt ikke mistet volum. Resultatet overgikk alle forventninger. Jeg føler meg som meg selv igjen.',
  'testimonial5.highlight': 'Jeg føler meg som meg selv igjen',

  // Testimonial 6
  'testimonial6.category': 'FMD-protokoll',
  'testimonial6.name': 'Irina N.',
  'testimonial6.text': 'Biohacking som virkelig fungerer. Etter protokollen glemte jeg kveldstretthet og tåke i hodet. Jeg føler meg på toppen. Dette er ikke bare detox — det er en vitenskapelig tilnærming til foryngelse på cellulært nivå.',
  'testimonial6.highlight': 'Glemte kveldstretthet og tåke i hodet',

  // Bottom CTA
  'cta.title': 'Klar til å skrive din suksesshistorie?',
  'cta.description': 'Bli med hundrevis av klienter som allerede har endret livet sitt med vår hjelp',
  'cta.button': 'Bestill gratis diagnostikk',
};